module.exports = __webpack_public_path__ + "static/media/collageMaker.19482a0f.png";